import { useRecruitmentApi } from 'infrastructure/api';
import { FormFieldsData } from 'framework/form';
import { useRecruitingFinanceService } from 'domain/shared/recruitingFinance';

const useRecruiterExtension = () => {
  const { sendPostRequest } = useRecruitmentApi();
  const { saveBatchSensitiveRecruitingInfo } = useRecruitingFinanceService();

  const sendRejectionReason = async (data: FormFieldsData) => {
    const sensitiveCompensationData = data.expectedCompensationFrom
      ? await saveBatchSensitiveRecruitingInfo(
          [
            {
              value: data.expectedCompensationFrom,
              externalId: 'expectedCompensationFromId',
            },
            data.expectedCompensationTo && {
              value: data.expectedCompensationTo,
              externalId: 'expectedCompensationToId',
            },
          ].filter(Boolean),
        )
      : [];

    const expectedCompensationFromItem = sensitiveCompensationData.find(
      item => item.externalId === 'expectedCompensationFromId',
    );
    const expectedCompensationToItem = sensitiveCompensationData.find(
      item => item.externalId === 'expectedCompensationToId',
    );

    const response = await sendPostRequest('/candidate/rejection-reason', {
      vacancyGroupAlias: data.vacancyGroupAlias,
      location: data.location,
      rejectionReason: data.rejectionReason,
      expectedCompensationFromId: expectedCompensationFromItem?.id,
      expectedCompensationToId: expectedCompensationToItem?.id,
      compensationCurrency: data.compensationCurrency,
    });

    return response.json();
  };

  return {
    sendRejectionReason,
  };
};

export default useRecruiterExtension;
